import { fromReservation, fromMarket } from 'store/selectors';
import {
  changeAllGuestsNationality,
  changeAllGuestsAge,
  changeAllGuestsGender,
  changeAllGuestsTitle,
} from 'store/actions';

import factory from './factory/DropdownContainerFactory';

const getCustomerCategories = (state, { departureId }) => {
  const validCategories = fromReservation.getAgesForDeparture(state, departureId);
  const customerCategories = fromMarket.getAges(state);
  const filteredCategories = customerCategories.filter(c => validCategories.find(v => v.code === c.code));
  return filteredCategories;
};

const getNull = () => null;

const fields = {
  gender: [fromMarket.getGenders, changeAllGuestsGender, getNull],
  nationality: [fromMarket.getNationalities, changeAllGuestsNationality, getNull],
  customerCategory: [getCustomerCategories, changeAllGuestsAge, getNull],
  title: [fromMarket.getTitles, changeAllGuestsTitle, getNull],
};

export default factory(fields);



// WEBPACK FOOTER //
// ./src/containers/SelectAllDropdown.js